// Static domain data for Specialists.no — mirrors backend clinics.json where relevant.

export const CATEGORIES = [
  {
    slug: "estetikk-og-kosmetikk",
    name: "Estetikk & Kosmetikk",
    description: "Botox, fillers, plastisk kirurgi og estetiske behandlinger",
    icon: "sparkles",
    treatments: [
      "Botox / Rynkebehandling",
      "Fillers / Leppeforming",
      "Plastisk kirurgi",
      "Fettsuging",
    ],
  },
  {
    slug: "har-og-hodebunn",
    name: "Hår & Hodebunn",
    description: "Hårtransplantasjon, PRP og laserbehandling mot hårtap",
    icon: "sprout",
    treatments: [
      "Hårtransplantasjon",
      "PRP hårvekst",
      "Laserbehandling (hår)",
    ],
  },
  {
    slug: "hud-og-laser",
    name: "Hud & Laser",
    description: "Laser, hudforyngelse, akne og pigmentbehandling",
    icon: "sun",
    treatments: [
      "Laserbehandling (hud)",
      "Hudforyngelse",
      "Aknebehandling",
      "Pigmentflekker / Rosacea",
    ],
  },
  {
    slug: "tannhelse-og-smil",
    name: "Tannhelse & Smil",
    description: "Tannbleking, Invisalign, fasetter og kosmetisk tannlege",
    icon: "smile",
    treatments: [
      "Tannbleking",
      "Usynlig tannregulering (Invisalign)",
      "Kosmetisk tannlege",
      "Fasetter",
    ],
  },
  {
    slug: "fysioterapi-og-kiropraktor",
    name: "Fysioterapi & Kiropraktor",
    description: "Fysioterapi, kiropraktor, sportsmedisin og rehabilitering",
    icon: "activity",
    treatments: [
      "Fysioterapi (privat)",
      "Kiropraktor",
      "Sportsmedisin",
      "Rehabilitering",
      "Massasjeterapeut",
    ],
  },
  {
    slug: "oye-og-syn",
    name: "Øye & Syn",
    description: "LASIK, LASEK øyenlaser og privat synsundersøkelse",
    icon: "eye",
    treatments: [
      "Øyenlaser (LASIK/LASEK)",
      "Synsundersøkelse (privat)",
    ],
  },
  {
    slug: "ore-nese-hals",
    name: "Øre-Nese-Hals",
    description: "ØNH-spesialist, hørselstest og allergiutredning",
    icon: "ear",
    treatments: [
      "ØNH-spesialist (privat)",
      "Hørselstest",
      "Allergiutredning",
    ],
  },
];

// treatment slug -> treatment name (and reverse)
export const TREATMENT_SLUGS = {
  "botox": "Botox / Rynkebehandling",
  "fillers": "Fillers / Leppeforming",
  "plastisk-kirurgi": "Plastisk kirurgi",
  "fettsuging": "Fettsuging",
  "hartransplantasjon": "Hårtransplantasjon",
  "prp-harvekst": "PRP hårvekst",
  "laserbehandling-har": "Laserbehandling (hår)",
  "laserbehandling": "Laserbehandling (hud)",
  "hudforyngelse": "Hudforyngelse",
  "aknebehandling": "Aknebehandling",
  "pigmentflekker": "Pigmentflekker / Rosacea",
  "tannbleking": "Tannbleking",
  "invisalign": "Usynlig tannregulering (Invisalign)",
  "kosmetisk-tannlege": "Kosmetisk tannlege",
  "fasetter": "Fasetter",
  "fysioterapi": "Fysioterapi (privat)",
  "kiropraktor": "Kiropraktor",
  "sportsmedisin": "Sportsmedisin",
  "rehabilitering": "Rehabilitering",
  "massasjeterapeut": "Massasjeterapeut",
  "oyenlaser": "Øyenlaser (LASIK/LASEK)",
  "synsundersokelse": "Synsundersøkelse (privat)",
  "onh-spesialist": "ØNH-spesialist (privat)",
  "horselstest": "Hørselstest",
  "allergiutredning": "Allergiutredning",
};

export const CITIES = ["Oslo", "Drammen", "Asker", "Bærum", "Lillestrøm", "Sandvika", "Annet"];

export const CITY_SLUGS = {
  oslo: "Oslo",
  drammen: "Drammen",
  asker: "Asker",
  baerum: "Bærum",
  lillestrom: "Lillestrøm",
  sandvika: "Sandvika",
};

export const categoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);

export const slugifyTreatment = (name) => {
  const entry = Object.entries(TREATMENT_SLUGS).find(([, v]) => v === name);
  return entry ? entry[0] : name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
};
